import { ChallengeParticipation } from './challenge-participation';
import { ChallengeQuestion } from './challenge-question';

/**
 * Situacao do desafio
 */
export enum ChallengeStatus {
  /**
   * Publicada
   */
  PUBLISHED = 'PUBLISHED',

  /**
   * Não publicada
   */
  NOT_PUBLISHED = 'NOT_PUBLISHED',

  /**
   * Rascunho
   */
  DRAFT = 'DRAFT',
}

export const translateChallengeStatus = (status: ChallengeStatus): string => {
  switch (status) {
    case ChallengeStatus.PUBLISHED:
      return 'Publicado';
    case ChallengeStatus.NOT_PUBLISHED:
      return 'Não publicado';
    case ChallengeStatus.DRAFT:
      return 'Rascunho';
    default:
      return status;
  }
};

export const colorByChallengeStatus = (status: ChallengeStatus): string => {
  switch (status) {
    case ChallengeStatus.PUBLISHED:
      return 'brand.500';
    case ChallengeStatus.NOT_PUBLISHED:
      return 'gray.500';
    case ChallengeStatus.DRAFT:
      return 'gray.500';
    default:
      return 'gray.500';
  }
};

/**
 * Tipo de interatividade
 */
export enum ChallengeInteractivity {
  /**
   * Ativa
   */
  ENABLED = 'ENABLED',
  /**
   * Encerrada
   */
  CLOSED = 'CLOSED',
}

export const translateChallengeInteractivity = (status: ChallengeInteractivity): string => {
  switch (status) {
    case ChallengeInteractivity.ENABLED:
      return 'Ativo';
    case ChallengeInteractivity.CLOSED:
      return 'Encerrado';
    default:
      return status;
  }
};

export class Challenge {
  uuid: string;
  status: ChallengeStatus;
  interactivity: ChallengeInteractivity;
  title: string;
  time_limit_seconds: number;
  description: string;
  timeout_message: string;
  error_message: string;
  winner_message: string;
  communication_message: string;
  starts_in: string;
  question_count: number;
  total_participants: number;
  questions: ChallengeQuestion[];
  challengeParticipation: ChallengeParticipation[];
  winner?: {
    uuid: string;
    display_name: string;
    avatar_url: string;
    total_correct: number;
    total_time_seconds: number;
  };
  team_uuid?: string;
  team_name?: string;
  team_image?: string;
  created_at: string;
  updated_at: string;
}
